import { render } from "./LuxuryTravel03.vue?vue&type=template&id=0496481c&scoped=true"
import script from "./LuxuryTravel03.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel03.vue?vue&type=script&lang=js"

import "./LuxuryTravel03.scss?vue&type=style&index=0&id=0496481c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0496481c"]])

export default __exports__